import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    NotificationDto,
    NotificationRequestModel,
    NotificationScheduleDto,
    SubscribeListModel,
    UpdateStatusScheduleNotification
} from "../interfaces/notification.interface";
import { Observable } from "rxjs";
import { environment } from "@/environments/environment";
import { ResponsePagingModel } from "../interfaces/pagination.interface";
import { BaseResponseDataModel, BaseResponseModel } from "../interfaces/base-response.interface";

@Injectable({
    providedIn: "root",
})
export class PushNotificationService {
    constructor(private http: HttpClient) { }

    getLastestNotifications(): Observable<ResponsePagingModel<NotificationDto>> {
        let body: NotificationRequestModel = {
            limit: 5,
            offset: 0,
        }
        return this.http.post<ResponsePagingModel<NotificationDto>>(`${environment.baseURL}notification/notification/get-notifications`, body);
    }

    getNotifications(body: NotificationRequestModel): Observable<ResponsePagingModel<NotificationDto>> {
        return this.http.post<ResponsePagingModel<NotificationDto>>(`${environment.baseURL}notification/notification/get-notifications`, body);
    }
    getScheduledNotifications(body: NotificationRequestModel): Observable<ResponsePagingModel<NotificationScheduleDto>> {
        return this.http.post<ResponsePagingModel<NotificationScheduleDto>>(`${environment.baseURL}notification/schedulenotification/v1/get`, body);
    }
    getScheduledNotificationDetail(notiId: string): Observable<NotificationScheduleDto> {
        return this.http.get<NotificationScheduleDto>(`${environment.baseURL}notification/schedulenotification/v1/get-by-id/${notiId}`);
    }
    createScheduledNotification(payload: any) {
        return this.http.post(`${environment.baseURL}notification/schedulenotification/v1/create`, payload);
    }
    updateScheduledNotification(payload: NotificationScheduleDto): Observable<BaseResponseDataModel<NotificationScheduleDto>> {
        return this.http.post<BaseResponseDataModel<NotificationScheduleDto>>(`${environment.baseURL}notification/schedulenotification/v1/update`, payload);
    }
    updateStatusScheduledNotification(payload: UpdateStatusScheduleNotification): Observable<BaseResponseDataModel<NotificationScheduleDto>> {
        return this.http.post<BaseResponseDataModel<NotificationScheduleDto>>(`${environment.baseURL}notification/schedulenotification/v1/update-status`, payload);
    }
    duplicateScheduledNotification(id: string): Observable<BaseResponseDataModel<NotificationScheduleDto>> {
        return this.http.post<BaseResponseDataModel<NotificationScheduleDto>>(`${environment.baseURL}notification/schedulenotification/v1/duplicate`, JSON.stringify(id), {
            headers: {
                'Content-Type': 'application/json',
            }
        });
    }
    readNotification(notiId: string): Observable<boolean> {
        return this.http.post<boolean>(`${environment.baseURL}notification/notification/read-notification/${notiId}`, null);
    }
    getNotification(notiId: string): Observable<NotificationDto> {
        return this.http.get<NotificationDto>(`${environment.baseURL}notification/notification/get-notification/${notiId}`);
    }

    getSubscribeList(): Observable<SubscribeListModel[]> {
        return this.http.get<SubscribeListModel[]>(`${environment.baseURL}notification/topic/subscribe-list`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }

    updateSubscribeList(model: string[]): Observable<BaseResponseModel> {
        return this.http.post<BaseResponseModel>(`${environment.baseURL}notification/topic/subscribe-list`, model, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    subscribeToken(token: string): Observable<BaseResponseModel> {
        let model = {
            'token': token
        };
        return this.http.post<BaseResponseModel>(`${environment.baseURL}notification/topic/subscribe`, model, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    getUnreadNotification(): Observable<number> {
        return this.http.get<number>(`${environment.baseURL}notification/notification/count-unread-notification`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
}

